import React, { useState } from "react";

import PropTypes from "prop-types";

import constants from "@/utils/constants";

export const FloorPlanContext = React.createContext({});

const FloorPlanProvider = ({ children }) => {
  return (
    // The value has same format of useState hook: value = [appState, setAppState]
    <FloorPlanContext.Provider
      value={useState({
        activatedPosViewMode: constants.POS_VIEW_MODES.PRODUCTS_SELECTION,
      })}
    >
      {children}
    </FloorPlanContext.Provider>
  );
};

FloorPlanProvider.propTypes = {
  children: PropTypes.any,
};

export default FloorPlanProvider;
